import { css } from "@emotion/css";

export function DataFieldTable({ children }: React.PropsWithChildren) {
  return <div className={styles.container}>{children}</div>;
}

const styles = {
  container: css({
    borderBottom: "solid 1px",
    borderColor: "var(--border-base)",
    "&:last-child": {
      borderBottom: "none",
    },
  }),
};
